import { render, staticRenderFns } from "./StatsComplaintsModal.vue?vue&type=template&id=0ed247ba&"
import script from "./StatsComplaintsModal.vue?vue&type=script&lang=js&"
export * from "./StatsComplaintsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports